<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :tableData="tableData"
              :isSearch="isSearch"
              @add="add"
              @pageNumChange="pageNumChange">
      <div slot="table">
        <message-table :tableData="tableData.list" @update="update" @del="del"></message-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import MessageTable from "./MessageTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getSystemMessage,newVue,delByMessageId} from "../../network/message";

  export default {
    name: "orderList",
    components: {MessageTable, MyTable},
    data(){
      return {
        title: "系统消息列表",
        isAdd: true,
        isSearch: false,
        tableData:{},
        searchItems:{},
        orderState: ""
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/systemMessage/list";
      this.common.HeaderLocationTwo.name =  "系统消息管理"
      this.common.HeaderLocationThree.name = "系统消息列表"
      getSystemMessage().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      refresh(){
        getSystemMessage().then(res => {
          this.tableData = res.data
        })
      },
      pageNumChange(pageNum){
        this.getSystemMessage(pageNum).then(res => {
          this.tableData = res.data
        });
      },
      add(){
        this.$router.push("insert/");
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByMessageId(id).then(res => {
              this.refresh()
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>
